// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drink-item {
  display: flex;
  flex-direction: row;
  background-color: #ffffff;
  border: 1px solid #D9D9D9;
  border-radius: 18px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 120px;
}
.drink-item .drink-image-container {
  position: relative;
  width: 150px;
  min-width: 150px;
  height: auto;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.drink-item .drink-image-container .drink-image {
  width: 90px;
  height: 80px;
  object-fit: cover;
  display: block;
  border-radius: 10px;
}
.drink-item .drink-image-container .drink-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F5F5F5;
}
.drink-item .drink-image-container .drink-image-placeholder span {
  font-size: 12px;
  color: #8C8C8C;
}
.drink-item .drink-image-container .drink-image-placeholder.drink-icon-placeholder {
  background-color: #F5F5F5;
  width: 90px;
  height: 80px;
  border-radius: 10px;
}
.drink-item .drink-image-container .drink-image-placeholder.drink-icon-placeholder .drink-placeholder-icon {
  font-size: 40px;
  color: #A1A1A1;
}
.drink-item .drink-image-container .sold-out-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.7);
}
.drink-item .drink-image-container .sold-out-overlay .sold-out-badge {
  padding: 12px 24px;
  background-color: #A29061;
  color: #ffffff;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.drink-item .drink-image-container .selected-indicator {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  background-color: #CC9900;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.drink-item .drink-image-container .selected-indicator .selected-check-icon {
  font-size: 16px;
  color: #ffffff;
}
.drink-item .drink-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.drink-item .drink-details .drink-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.drink-item .drink-details .drink-info .drink-name-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}
.drink-item .drink-details .drink-info .drink-name-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.drink-item .drink-details .drink-info .drink-name {
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  margin: 0;
  line-height: 1.3;
}
.drink-item .drink-details .drink-info .drink-description {
  font-size: 13px;
  color: #8C8C8C;
  margin: 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.drink-item .drink-details .drink-info .drink-price {
  font-size: 16px;
  font-weight: 600;
  color: #8E7E54;
  margin: 0;
  white-space: nowrap;
  margin-right: 30px;
}
.drink-item:hover:not(.sold-out) {
  border-color: #CC9900;
}
.drink-item.selected {
  border-color: #CC9900;
  background-color: #FFF9E6;
}
.drink-item.sold-out {
  cursor: not-allowed;
  opacity: 1;
  pointer-events: none;
}
.drink-item.sold-out .drink-details .drink-info .drink-name,
.drink-item.sold-out .drink-details .drink-info .drink-description,
.drink-item.sold-out .drink-details .drink-info .drink-price {
  opacity: 1;
}
/*# sourceMappingURL=DrinkItem.css.map */`, "",{"version":3,"sources":["webpack://./DrinkItem.less","webpack://./src/containers/BookingPage/components/DrinkItem.less"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;ACCD;ADVA;EAYE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ACCF;ADrBA;EAuBG,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;ACCH;AD5BA;EA+BG,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;ACAH;ADpCA;EAuCI,eAAA;EACA,cAAA;ACAJ;ADGG;EACC,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;ACDJ;ADHG;EAOE,eAAA;EACA,cAAA;ACDL;ADlDA;EAyDG,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;ACJH;AD7DA;EAoEI,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;ACJJ;ADvEA;EAgFG,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ACNH;ADnFA;EA4FI,eAAA;EACA,cAAA;ACNJ;ADvFA;EAmGE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;ACTF;AD7FA;EAyGG,aAAA;EACA,sBAAA;EACA,QAAA;ACTH;ADlGA;EA8GI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;ACTJ;ADxGA;EAqHI,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;ACVJ;AD9GA;EA4HI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;ACXJ;ADrHA;EAoII,eAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;ACZJ;AD/HA;EA+II,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;ACbJ;ADkBC;EACC,qBAAA;AChBF;ADmBC;EACC,qBAAA;EACA,yBAAA;ACjBF;ADoBC;EACC,mBAAA;EACA,UAAA;EACA,oBAAA;AClBF;ADeC;;;EAUI,UAAA;ACpBL;AACA,wCAAwC","sourcesContent":[".drink-item {\n\tdisplay: flex;\n\tflex-direction: row;\n\tbackground-color: #ffffff;\n\tborder: 1px solid #D9D9D9;\n\tborder-radius: 18px;\n\toverflow: hidden;\n\tcursor: pointer;\n\ttransition: all 0.3s ease;\n\tmin-height: 120px;\n\n\t.drink-image-container {\n\t\tposition: relative;\n\t\twidth: 150px;\n\t\tmin-width: 150px;\n\t\theight: auto;\n\t\toverflow: hidden;\n\t\tflex-shrink: 0;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\n\t\t.drink-image {\n\t\t\twidth: 90px;\n\t\t\theight: 80px;\n\t\t\tobject-fit: cover;\n\t\t\tdisplay: block;\n\t\t\tborder-radius: 10px;\n\t\t}\n\n\t\t.drink-image-placeholder {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tbackground-color: #F5F5F5;\n\n\t\t\tspan {\n\t\t\t\tfont-size: 12px;\n\t\t\t\tcolor: #8C8C8C;\n\t\t\t}\n\n\t\t\t&.drink-icon-placeholder {\n\t\t\t\tbackground-color: #F5F5F5;\n\t\t\t\twidth: 90px;\n\t\t\t\theight: 80px;\n\t\t\t\tborder-radius: 10px;\n\n\t\t\t\t.drink-placeholder-icon {\n\t\t\t\t\tfont-size: 40px;\n\t\t\t\t\tcolor: #A1A1A1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.sold-out-overlay {\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tbackground-color: rgba(255, 255, 255, 0.7);\n\n\t\t\t.sold-out-badge {\n\t\t\t\tpadding: 12px 24px;\n\t\t\t\tbackground-color: #A29061;\n\t\t\t\tcolor: #ffffff;\n\t\t\t\tborder-radius: 4px;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tletter-spacing: 0.5px;\n\t\t\t}\n\t\t}\n\n\t\t.selected-indicator {\n\t\t\tposition: absolute;\n\t\t\ttop: 8px;\n\t\t\tright: 8px;\n\t\t\twidth: 28px;\n\t\t\theight: 28px;\n\t\t\tbackground-color: #CC9900;\n\t\t\tborder-radius: 50%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\n\t\t\t.selected-check-icon {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tcolor: #ffffff;\n\t\t\t}\n\t\t}\n\t}\n\n\t.drink-details {\n\t\tflex: 1;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\n\t\t.drink-info {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 4px;\n\n\t\t\t.drink-name-row {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\talign-items: center;\n\t\t\t\tgap: 12px;\n\t\t\t}\n\n\t\t\t.drink-name-section {\n\t\t\t\tflex: 1;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 2px;\n\t\t\t}\n\n\t\t\t.drink-name {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tcolor: #262626;\n\t\t\t\tmargin: 0;\n\t\t\t\tline-height: 1.3;\n\t\t\t}\n\n\t\t\t.drink-description {\n\t\t\t\tfont-size: 13px;\n\t\t\t\tcolor: #8C8C8C;\n\t\t\t\tmargin: 0;\n\t\t\t\tline-height: 1.4;\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t-webkit-line-clamp: 2;\n\t\t\t\t-webkit-box-orient: vertical;\n\t\t\t\toverflow: hidden;\n\t\t\t}\n\n\t\t\t.drink-price {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tcolor: #8E7E54;\n\t\t\t\tmargin: 0;\n\t\t\t\twhite-space: nowrap;\n\t\t\t\tmargin-right: 30px;\n\t\t\t}\n\t\t}\n\t}\n\n\t&:hover:not(.sold-out) {\n\t\tborder-color: #CC9900;\n\t}\n\n\t&.selected {\n\t\tborder-color: #CC9900;\n\t\tbackground-color: #FFF9E6;\n\t}\n\n\t&.sold-out {\n\t\tcursor: not-allowed;\n\t\topacity: 1;\n\t\tpointer-events: none;\n\n\t\t.drink-details {\n\t\t\t.drink-info {\n\t\t\t\t.drink-name,\n\t\t\t\t.drink-description,\n\t\t\t\t.drink-price {\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n",".drink-item {\n  display: flex;\n  flex-direction: row;\n  background-color: #ffffff;\n  border: 1px solid #D9D9D9;\n  border-radius: 18px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-height: 120px;\n}\n.drink-item .drink-image-container {\n  position: relative;\n  width: 150px;\n  min-width: 150px;\n  height: auto;\n  overflow: hidden;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.drink-item .drink-image-container .drink-image {\n  width: 90px;\n  height: 80px;\n  object-fit: cover;\n  display: block;\n  border-radius: 10px;\n}\n.drink-item .drink-image-container .drink-image-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #F5F5F5;\n}\n.drink-item .drink-image-container .drink-image-placeholder span {\n  font-size: 12px;\n  color: #8C8C8C;\n}\n.drink-item .drink-image-container .drink-image-placeholder.drink-icon-placeholder {\n  background-color: #F5F5F5;\n  width: 90px;\n  height: 80px;\n  border-radius: 10px;\n}\n.drink-item .drink-image-container .drink-image-placeholder.drink-icon-placeholder .drink-placeholder-icon {\n  font-size: 40px;\n  color: #A1A1A1;\n}\n.drink-item .drink-image-container .sold-out-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(255, 255, 255, 0.7);\n}\n.drink-item .drink-image-container .sold-out-overlay .sold-out-badge {\n  padding: 12px 24px;\n  background-color: #A29061;\n  color: #ffffff;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n.drink-item .drink-image-container .selected-indicator {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 28px;\n  height: 28px;\n  background-color: #CC9900;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.drink-item .drink-image-container .selected-indicator .selected-check-icon {\n  font-size: 16px;\n  color: #ffffff;\n}\n.drink-item .drink-details {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.drink-item .drink-details .drink-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.drink-item .drink-details .drink-info .drink-name-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n.drink-item .drink-details .drink-info .drink-name-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.drink-item .drink-details .drink-info .drink-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: #262626;\n  margin: 0;\n  line-height: 1.3;\n}\n.drink-item .drink-details .drink-info .drink-description {\n  font-size: 13px;\n  color: #8C8C8C;\n  margin: 0;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.drink-item .drink-details .drink-info .drink-price {\n  font-size: 16px;\n  font-weight: 600;\n  color: #8E7E54;\n  margin: 0;\n  white-space: nowrap;\n  margin-right: 30px;\n}\n.drink-item:hover:not(.sold-out) {\n  border-color: #CC9900;\n}\n.drink-item.selected {\n  border-color: #CC9900;\n  background-color: #FFF9E6;\n}\n.drink-item.sold-out {\n  cursor: not-allowed;\n  opacity: 1;\n  pointer-events: none;\n}\n.drink-item.sold-out .drink-details .drink-info .drink-name,\n.drink-item.sold-out .drink-details .drink-info .drink-description,\n.drink-item.sold-out .drink-details .drink-info .drink-price {\n  opacity: 1;\n}\n/*# sourceMappingURL=DrinkItem.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
